/* eslint-disable */
import i18n from '@/locales/i18n';
import isAdminUser from '@produtos/store-access-provider/src/utils/is-admin-user';
import isCompanyUser from '@produtos/store-access-provider/src/utils/is-company-user';
import isDeveloperUser from '@produtos/store-access-provider/src/utils/is-developer-user';
import isSupportUser from '@produtos/store-access-provider/src/utils/is-support-user';
/* eslint-enable */

export default /** @type { import('vuex').Module } */ ({
  namespaced: true,

  state: {
    menus: {
      dashboard: {
        icon: 'mdi-view-dashboard-outline',
        label: 'Dashboard',
        to: '/',
      },
      myusers: {
        icon: 'mdi-account-supervisor',
        label: i18n.t('myusers.users'),
        to: '/myusers',
      },
      mycompanies: {
        icon: 'mdi-store-outline',
        label: i18n.t('mycompanies.mycompanies'),
        to: '/mycompanies',
      },
      mytransactions: {
        icon: 'mdi-cloud-sync',
        label: i18n.t('mytransactions.mytransactions'),
        to: '/mytransactions',
      },
    },
  },

  getters: {
    services: (state, getters, rootState, rootGetters) => rootGetters['accessProvider/services'],
    menus: (state, getters, rootState, rootGetters) => {
      const profile = rootGetters['auth/profile'];

      if (isCompanyUser(profile?.tags)) {
        return [
          state.menus.dashboard,
          state.menus.myusers,
          state.menus.mytransactions,
        ];
      }

      if (isAdminUser(profile?.tags)) {
        return [
          state.menus.dashboard,
          state.menus.mycompanies,
          state.menus.mytransactions,
        ];
      }

      if (isSupportUser(profile?.tags) || isDeveloperUser(profile?.tags)) {
        return [
          state.menus.dashboard,
          state.menus.mycompanies,
          state.menus.mytransactions,
        ];
      }

      return [
        state.menus.dashboard,
        state.menus.mytransactions,
      ];
    },
  },
});
